/**
 * @generated SignedSource<<82d7c4c101f67dc5c5879e55b4611b09>>
 * @relayHash 4752765c6ea0f79f3a6b09aef1c91260
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a6d5f414439869db88a1b01d0cd99291f9e8743055bc86f367b873fe3c8bf151

import { ConcreteRequest } from 'relay-runtime';
export type branchExplorerPageQuery$variables = {
  account: string;
  branch: string;
  graph: string;
};
export type branchExplorerPageQuery$data = {
  readonly branch: {
    readonly endpointConfig: {
      readonly url: string;
    } | null | undefined;
  };
};
export type branchExplorerPageQuery = {
  response: branchExplorerPageQuery$data;
  variables: branchExplorerPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "account"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "branch"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "graph"
},
v3 = [
  {
    "kind": "Variable",
    "name": "accountSlug",
    "variableName": "account"
  },
  {
    "kind": "Variable",
    "name": "graphSlug",
    "variableName": "graph"
  },
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "branch"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "EndpointConfig",
  "kind": "LinkedField",
  "name": "endpointConfig",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "branchExplorerPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v3/*: any*/),
          "concreteType": "Branch",
          "kind": "LinkedField",
          "name": "branch",
          "plural": false,
          "selections": [
            (v4/*: any*/)
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "branchExplorerPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Branch",
        "kind": "LinkedField",
        "name": "branch",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4752765c6ea0f79f3a6b09aef1c91260",
    "id": "a6d5f414439869db88a1b01d0cd99291f9e8743055bc86f367b873fe3c8bf151",
    "metadata": {},
    "name": "branchExplorerPageQuery",
    "operationKind": "query",
    "text": "query branchExplorerPageQuery(\n  $account: String!\n  $graph: String!\n  $branch: String!\n) {\n  branch(accountSlug: $account, graphSlug: $graph, name: $branch) {\n    endpointConfig {\n      url\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c057593aee547473f5c0abd82f473f14";

export default node;
